<script setup>
// 活動站共用頁尾。上緣的山稜線是設計稿的一部分，會往上疊在前一個區塊上，
// 所以放在頁尾裡（bottom: 100%），前一個區塊只要留夠 padding-bottom 即可。
import siteLogo from '~/assets/img/logo.png'
import ridgeImg from '~/assets/img/ridge.png'

defineProps({
  // 山稜線只適合疊在淺色區塊上，其他頁面若上方不是淺色可傳 false 關掉
  ridge: { type: Boolean, default: true }
})

const columns = [
  {
    title: '115年全民親山步道票選活動',
    items: ['主辦單位：運動部全民運動署', '執行單位：永悅健康股份有限公司']
  },
  {
    title: '聯絡我們',
    items: [
      '活動小組聯絡電話：02-2912-5566#7424',
      '聯絡時間：週一至週五 10:00-12:00、13:30-18:00',
      '信箱：hikingnote115@gmail.com'
    ]
  }
]
</script>

<template>
  <footer class="site-footer">
    <span
      v-if="ridge"
      class="ridge"
      aria-hidden="true"
      :style="{ backgroundImage: `url(${ridgeImg})` }"
    ></span>

    <div class="foot-inner">
      <img
        class="foot-logo"
        :src="siteLogo"
        alt="115年全民親山步道票選活動"
        width="156"
        height="32"
      />
      <div v-for="col in columns" :key="col.title" class="foot-col">
        <h3>{{ col.title }}</h3>
        <p v-for="line in col.items" :key="line">{{ line }}</p>
      </div>
    </div>

    <div class="foot-bar">Copyright © 2026 H2U Corp. All rights reserved</div>
  </footer>
</template>

<style scoped>
.site-footer {
  position: relative;
  background: #f6f6f6;
  font-family: var(--site-font);
  color: var(--site-ink-soft);
}

/* 稜線圖底部本身就是 #f6f6f6，直接和頁尾底色接起來，看不出交界 */
.ridge {
  position: absolute;
  left: 0;
  bottom: 100%;
  width: 100%;
  aspect-ratio: 1440 / 175;
  /* 稜線是往上疊在前一區塊上的，長度不能超過對方預留的 175px（設計稿 1440 寬的高度），
     否則寬螢幕上等比長高就會蓋到人家的內容；超過 1440 之後改成橫向拉伸，剪影看不出來 */
  max-height: 175px;
  background-position: center bottom;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  pointer-events: none;
}

.foot-inner {
  max-width: var(--site-max);
  margin: 0 auto;
  padding: 70px 0 60px;
  display: grid;
  grid-template-columns: 260px 1fr 1fr;
  gap: 32px;
}

.foot-logo {
  display: block;
  height: 32px;
  width: auto;
}

/* 行距一律用比例：手機把字級縮小時，行距才會跟著收，不會整欄散開 */
.foot-col h3 {
  margin: 0;
  font-size: 22px;
  line-height: 1.6;
  font-weight: 700;
  color: #3c4043;
}

.foot-col p {
  margin: 0;
  font-size: 18px;
  line-height: 1.9;
  color: #3c4043;
}

.foot-col p:last-child {
  margin-bottom: 0;
}

.foot-bar {
  padding: 15px 20px;
  background: var(--site-orange);
  color: #fff;
  font-size: 16px;
  line-height: 1.6;
  text-align: center;
}

@media (max-width: 900px) {
  .foot-inner {
    grid-template-columns: 1fr;
    gap: 28px;
    padding: 44px 20px 40px;
  }

  .foot-col h3 {
    margin-bottom: 12px;
    font-size: 16px;
    line-height: 1.5;
  }

  /* 桌機那組寬鬆行距是為了拉開三欄的節奏，單欄堆疊時會顯得鬆散 */
  .foot-col p {
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 1.7;
  }

  .foot-bar {
    font-size: 12px;
    line-height: 1.6;
  }
}
</style>
